//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AnionGapSerum',
  components: {},
  data () {
    return {
      form: {
        hco3: '',
        albumin: '',
        cl: '',
        measureBlood: ''
      },
      hasScore: false,
      disabled: false,
      descTxt: ''
    }
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.measureBlood - (form.cl + form.hco3)
      if (form.albumin < 35 && form.albumin !== '') {
        result = form.measureBlood - (form.cl + form.hco3) + 0.25 * (40 - form.measureBlood)
      }
      console.log(result, form, 'form')
      self.hasScore = true
      if (result < 17 && result > 7) {
        self.descTxt = '正常阴离子间隙'
      } else {
        self.descTxt = '不正常阴离子间隙'
      }
      return String(result.toFixed(0))
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GD/AnionGapSerum.vue